import React, { useMemo } from 'react';
import { BaseModal } from '../BaseModal';
import {PrimaryButton, TransprentButton} from '../../Buttons'

import {
    ModalHeading,
    ModalDescription,
} from './style'

export const ConfirmationModal = ({
    heading,
    description,
    onOk,
    onCancel,
    btnProps,
    cancelBtnText,
    okBtnText,
    ...rest
}) => {
    const [okBtnProps, cancelBtnProps] = useMemo(() => {
        const { okBtnProps = {}, cancelBtnProps = {} } = btnProps || {};
        return [okBtnProps, cancelBtnProps]
    }, [btnProps])

    const content = useMemo(() => {
        return(
            <React.Fragment>
                <ModalHeading>{heading}</ModalHeading>
                <ModalDescription>{description}</ModalDescription>
            </React.Fragment>
        )
    }, [heading, description]);

    const actionChildren = useMemo(() => {
        return(
            <React.Fragment>
                <TransprentButton {...cancelBtnProps} onClick={onCancel} >{cancelBtnText}</TransprentButton>
                <PrimaryButton {...okBtnProps} onClick={onOk}>{okBtnText}</PrimaryButton>
            </React.Fragment>
        )
    }, [onCancel, onOk, cancelBtnText, okBtnText, cancelBtnProps, okBtnProps]);

    return (
        <BaseModal
            content={content}
            actionChildren={actionChildren}
            onClose={onCancel}
            {...rest}
        />
    )
}

ConfirmationModal.defaultProps = {
    btnProps: {},
    okBtnText: 'Proceed',
    cancelBtnText: 'Cancel',
    onCancel: () => { }
}



